import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { BagActionTypes } from '@state/features/common.types';
import { createBrowserHistory } from 'history';
import ReduxQuerySync from 'redux-query-sync';
import customEventBus from '../scripts/libs/eventBus';
import accordionstepsSlice from './features/accordion.slice';
import { accountRootReducer, accountRootSaga } from './features/account.index';
import { bagRootReducer, bagRootSaga } from './features/bag.index';
import { checkoutRootReducer, checkoutRootSaga } from './features/checkout.index';
import { connectivityRootReducer, connectivityRootSaga } from './features/connectivity.index';
// import { rootReducer, rootSaga } from './features/listing.index';
// import { MinicartApplicationState, minicartRootReducer, minicartRootSaga } from './features/minicart.index';
// import { searchReducer } from './features/search.index';
// import searchSaga from './features/search.saga';
// import { StoreLocatorApplicationState, storelocatorReducer, storelocatorRootSaga } from './features/storelocator.index';
import sagaMiddleware from './middlewares/saga.middleware';
const middleware = [...getDefaultMiddleware({ thunk: true }), sagaMiddleware];
const saveState = (state
// | StoreLocatorApplicationState
) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem('ib-state', serializedState);
    }
    catch (e) {
        // Ignore write errors;
    }
};
const basename = '/';
export const history = createBrowserHistory();
//check this https://github.com/reduxjs/redux-toolkit/issues/282
// const configureCatalogStore = () => {
//   const store = configureStore({
//     reducer: rootReducer,
//     devTools: { name: 'PLP/PDP' },
//     middleware,
//     // https://jira.industries-group.com/browse/ONE-33630
//     // enhancers: [
//     //   ReduxQuerySync.enhancer({
//     //     params: {
//     //       sizeguide: {
//     //         selector: (state: ApplicationState) => state.product.sizeguide,
//     //         action: (sizeguide: string) => {
//     //           return productSlice.actions.updateSizeguide(sizeguide === 'true' || undefined);
//     //         },
//     //       },
//     //     },
//     //     initialTruth: 'location',
//     //     replaceState: true,
//     //   }),
//     // ],
//   });
//   sagaMiddleware.run(rootSaga);
//   store.subscribe(() => saveState(store.getState()));
//   return store;
// };
// const configureSearchStore = () => {
//   const store = configureStore({
//     reducer: searchReducer,
//     devTools: { name: 'Search' },
//     middleware,
//   });
//   sagaMiddleware.run(searchSaga);
//   store.subscribe(() => saveState(store.getState()));
//   return store;
// };
// const configureMinicartStore = () => {
//   const store = configureStore({
//     reducer: minicartRootReducer,
//     devTools: { name: 'Minicart' },
//     middleware,
//   });
//   sagaMiddleware.run(minicartRootSaga);
//   store.subscribe(() => {
//     saveState(store.getState());
//   });
//   customEventBus.on('minicart:update', (data: any) => {
//     console.info('minicart:update received');
//     if (data?.fromAddToBag) {
//       store.dispatch({
//         type: MinicartActionTypes.FETCH_MINICART_AFTER_UPDATE,
//         payload: {
//           fromKeyboard: data?.fromKeyboard,
//           pid: data?.pid,
//           closeDeelay: data?.closeDeelay || 4000,
//         },
//       });
//     } else {
//       store.dispatch({
//         type: MinicartActionTypes.UPDATE_MINICART,
//         payload: {
//           fromBag: true,
//         },
//       });
//     }
//   });
//   return store;
// };
// const configureChatStore = () => {
//   const store = configureStore({
//     reducer: minicartRootReducer,
//     devTools: { name: 'Livechat (minicart store)' },
//     middleware,
//   });
//   sagaMiddleware.run(minicartRootSaga);
//   store.subscribe(() => saveState(store.getState()));
//   return store;
// };
const configureBagStore = () => {
    const store = configureStore({
        reducer: bagRootReducer,
        devTools: { name: 'Bag' },
        middleware,
    });
    sagaMiddleware.run(bagRootSaga);
    store.subscribe(() => {
        saveState(store.getState());
    });
    customEventBus.on('bag:update', (data) => {
        console.info('bag:update received');
        store.dispatch({
            type: BagActionTypes.FETCH_BAG,
            payload: {
                fromMinicart: true,
            },
        });
    });
    return store;
};
const configureCheckoutStore = () => {
    const store = configureStore({
        reducer: checkoutRootReducer,
        devTools: { name: 'Checkout' },
        middleware,
        enhancers: [
            ReduxQuerySync.enhancer({
                params: {
                    step: {
                        selector: (state) => state.step.step,
                        action: (newStep) => {
                            return accordionstepsSlice.actions.updateStep(newStep || '');
                        },
                        defaultValue: '',
                    },
                },
                initialTruth: 'location',
                replaceState: true,
            }),
        ],
    });
    sagaMiddleware.run(checkoutRootSaga);
    store.subscribe(() => {
        saveState(store.getState());
    });
    return store;
};
const configureConnectivityStore = () => {
    const store = configureStore({
        reducer: connectivityRootReducer,
        devTools: { name: 'Connectivity' },
        middleware,
        enhancers: [
            ReduxQuerySync.enhancer({
                params: {
                    step: {
                        selector: (state) => state.step.step,
                        action: (newStep) => {
                            return accordionstepsSlice.actions.updateStep(newStep || '');
                        },
                        defaultValue: '',
                    },
                },
                initialTruth: 'location',
                replaceState: true,
            }),
        ],
    });
    sagaMiddleware.run(connectivityRootSaga);
    store.subscribe(() => {
        saveState(store.getState());
    });
    return store;
};
const configureAccountStore = () => {
    const store = configureStore({
        reducer: accountRootReducer,
        devTools: { name: 'Account' },
        middleware,
        enhancers: [
            ReduxQuerySync.enhancer({
                params: {
                    step: {
                        selector: (state) => state.step.step,
                        action: (newStep) => {
                            return accordionstepsSlice.actions.updateStep(newStep || 'orderNumber');
                        },
                    },
                },
                initialTruth: 'location',
                replaceState: true,
            }),
        ],
    });
    sagaMiddleware.run(accountRootSaga);
    store.subscribe(() => {
        saveState(store.getState());
    });
    return store;
};
// const configureStoreLocatorStore = () => {
//   const store = configureStore({
//     reducer: storelocatorReducer,
//     devTools: { name: 'StoreLocator' },
//     middleware,
//   });
//   sagaMiddleware.run(storelocatorRootSaga);
//   store.subscribe(() => saveState(store.getState()));
//   return store;
// };
export { configureAccountStore, configureBagStore, 
// configureCatalogStore,
// configureChatStore,
configureCheckoutStore, configureConnectivityStore
// configureMinicartStore,
// configureSearchStore,
//configureUiStore,
// configureStoreLocatorStore,
 };
